var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallTrackingNumberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 164C135.899 164 165 134.899 165 99C165 63.1015 135.899 34 100 34C64.1015 34 35 63.1015 35 99C35 134.899 64.1015 164 100 164Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8332 151C128.092 151 151 128.092 151 99.8333C151 71.5747 128.092 48.6666 99.8332 48.6666C71.5746 48.6666 48.6665 71.5747 48.6665 99.8333C48.6665 128.092 71.5746 151 99.8332 151Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.91 123.804C122.217 120.524 115.89 118.117 110.983 118.171C109.517 119.264 106.617 122.371 105.57 123.864C95.9299 121.877 85.9765 107.997 84.4032 101.497C86.0699 100.764 89.6765 98.5172 91.0365 97.2906C92.0365 92.4906 90.9032 85.8172 88.3965 81.5572C85.4899 81.0706 78.4766 81.2106 73.4099 83.5172C73.1099 111.737 89.1765 136.571 122.07 137.064C125.31 132.537 125.83 126.751 125.91 123.804Z",
    fill: "#AEAEAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.426 118.42C118.733 115.14 112.407 112.733 107.5 112.787C106.033 113.88 103.133 116.987 102.086 118.48C92.4465 116.493 82.4931 102.613 80.9198 96.1132C82.5865 95.3799 86.1931 93.1332 87.5531 91.9065C88.5531 87.1065 87.4198 80.4332 84.9131 76.1732C82.0065 75.6865 74.9932 75.8265 69.9265 78.1332C69.6265 106.353 85.6931 131.187 118.586 131.68C121.826 127.153 122.346 121.367 122.426 118.42Z",
    fill: "#FF5000",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.313 80.7533V74.6466",
    stroke: "#4D4D4D",
    strokeWidth: 3.33654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.473 83.8065L112.527 77.6998",
    stroke: "#4D4D4D",
    strokeWidth: 3.33654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.581 89.9132L121.694 86.8599",
    stroke: "#4D4D4D",
    strokeWidth: 3.33654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.633 99.08H124.747",
    stroke: "#4D4D4D",
    strokeWidth: 3.33654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallTrackingNumberIcon);
export default __webpack_public_path__ + "static/media/call-tracking-number-icon.e395c9250000595542458c8cc4aac3d7.svg";
export { ForwardRef as ReactComponent };